@if (!migrationBannerDismissed()) {
  <!-- fixme: to be removed somewhere after summer 2025? -->
  <app-alert (close)="dismissBanner()">
    <span class="font-bold text-sm">Welkom op onze nieuwe Skillz website!</span>
    <span class="font-normal text-sm">
      Je kan nog steeds inloggen met jouw gekende Skillzlogin, je dient enkel je
      wachtwoord aan te passen via "Wachtwoord vergeten" om samen met ons een
      verse start te maken.
    </span>
  </app-alert>
}
<main class="flex-grow">
  <router-outlet />
</main>

<app-frontend-footer></app-frontend-footer>
